module.exports = __webpack_public_path__ + "img/IMG_2729_L_BlackMatted.8a393651.jpg";